export interface ImportantNotice { id: string; publishedAt: string; title: string; body: string; severity: "important" | "maintenance" }
export const IMPORTANT_NOTICES: readonly ImportantNotice[] = [
  { id: "2026-08-07-runtime-maturity", publishedAt: "2026-08-07", title: "运行稳定性与存档保护升级", body: "主界面现已加入错误恢复、存档 V5、回合检查点、故事导航和本地诊断。云备份仍需手动触发；匿名在线统计仍需明确同意。", severity: "important" },
] as const;
